import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

@connect(store => {
    return {
        project: store.project
    };
})

class DeleteUser extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: null
        }
    }

    render() {
        const { dispatch, project } = this.props;

        const handleRemove = () => {
            if (this.props.onRemove) {
                this.props.onRemove();
            }
            $("#remove-user").modal("hide");
        }

        return (
            <div class="modal fade delete-modal bg-overlay" id="remove-user" data-backdrop="static" data-keyboard="false">
                <div class={`modal-dialog modal-md`} role="document">
                    <div class="modal-content">
                        <div class="modal-header border-none pd20 pdl40 pdr40">
                            <div class="row">
                                <div class="col-lg-10 col-md-10 col-sm-10">
                                    <p class="text-size18 text-sldred text-semi-bold mb0">Remove Member from Account?</p>
                                </div>
                                <div class="col-lg-2 col-md-2 col-sm-2">
                                    <a  class="text-right text-black" data-dismiss="modal" aria-label="Close">
                                        <i class="material-icons text-black text-size22">close</i>
                                    </a>
                                </div>
                            </div>    
                        </div>
                        <div class="modal-body bt">
                            {this.props.member.activeTask > 0? <p class="m0 text-black">This user has existing tasks. Removing this member will leave the tasks unassigned. Do you wish to proceed?</p>
                            : <p class="m0 text-black">Do you wish to proceed?</p>}
                        </div>
                        <div class="modal-footer bt">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-4">
                                    <button type="button" class={`btn btn-secondary btn-cancel text-black`} data-dismiss="modal">No</button>
                                </div>
                                <div class="col-lg-8 col-md-8 col-sm-8 text-align-right">
                                    <button type="button" class={`btn btn-danger btn-delete`} onClick={handleRemove}>Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

DeleteUser.defaultProps = {
    member: {}
}

export default DeleteUser;